import { render, staticRenderFns } from "./ChatAnalysis.vue?vue&type=template&id=062cdc64&scoped=true&"
import script from "./ChatAnalysis.vue?vue&type=script&lang=js&"
export * from "./ChatAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ChatAnalysis.vue?vue&type=style&index=0&id=062cdc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062cdc64",
  null
  
)

export default component.exports